module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921042649_T.d22cfaa9.jpg";